/**
 * Global.ts
 * This creates and manages the global module $sflyBridge in browser
 */

import { EventHandler } from "./EventHandler";
import { HttpHandler } from "./HttpHandler";
import { LazyLoader } from "./LazyLoader";

export class GlobalModule {
    public Binder: EventHandler;
    public Loader: LazyLoader;
    public Ajax: HttpHandler;
    public plugins: any = {};
    public ready: boolean;
    public redundantLoadCount: number = 0;

    constructor() {
        this.Loader = new LazyLoader();
        this.Ajax = new HttpHandler();
    }

    public dispatch(eventName: string, eventDataObject: any) {
        const eh = new EventHandler(document);
        eh.dispatch(eventName, eventDataObject);
    }

    public on(eventName: string, eventCallBack: (evtData: any) => void, justOnce: boolean = false) {
        const eh = new EventHandler(document);
        eh.on(eventName, eventCallBack, justOnce);
    }

    public addPlugin(pluginName: string, newPlugin: any) {
        this.plugins[pluginName] = newPlugin;
    }
}

export let $sflyBridge = new GlobalModule();

let redundantLoadCount = 0;
if (window.$sflyBridge) {
    // this can happen when the script was loaded multiple times on a page
    // and the bootstrap had to remove the dupes.
    redundantLoadCount = window.$sflyBridge.redundantLoadCount;
}
(window as any).$sflyBridge = $sflyBridge;
window.$sflyBridge.redundantLoadCount = redundantLoadCount;
